exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.img-preview {\n  height: 50px;\n  width: 50px;\n  display: block\n}\n.SocieteTableHeader {\n  background-color: red!important;\n  padding-bottom: 50px;\n}\n", ""]);

// exports
